module.exports = __webpack_public_path__ + "media/images/mypage/icon/green/ico_search-8ccd4df9b074e724b5e2789dfcb1fb92.svg";